import { Link } from "react-router-dom";
import { Crane, Handshake, UsersThree } from "@phosphor-icons/react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { usePageSeo } from "@/hooks/usePageSeo";
import { images } from "@/data/site";

const services = [
  { id: "transaction-support", icon: Handshake, title: "Transaction Support", text: "Commission-model commercial coordination for project transactions.", link: "/contact", items: ["Intermediary payment processing", "Pre-payment services", "Post-payment services", "Transaction coordination", "Commercial support"] },
  { id: "manpower-supply", icon: UsersThree, title: "Manpower Supply", text: "Skilled, civil, and support manpower for short-term and long-term deployments.", link: "/manpower", items: ["Mechanical engineers, supervisors, and foremen", "Fabricators, fitters, welders, riggers, and operators", "Civil engineers, supervisors, masons, carpenters, and helpers", "Cooks, office support, housekeeping, and general helpers"] },
  { id: "equipment-rental", icon: Crane, title: "Equipment Rental", text: "Maintained plant and machinery with operators where required.", link: "/equipment", items: ["Crawler and tyre mounted cranes", "Straight and articulated boom manlifts", "Excavators, backhoe loaders, trailers, trucks, and dumpers", "DG sets and air compressors"] },
];

export default function ServicesPage() {
  usePageSeo({ title: "Industrial Services | Shyam Equipment and Infratech", description: "Transaction support, manpower supply, and plant and machinery rental services for PAN India industrial, refinery, EPC, and construction projects.", path: "/services" });
  return (
    <main className="text-industrial-text" data-testid="services-page">
      <Header />
      <PageHero eyebrow="Our Services" title="Project support without fragmented vendors" description="Three coordinated service verticals for industrial, refinery, infrastructure, EPC, and construction projects across India." image={images.hero} imageAlt="Cranes supporting an industrial construction project" testId="services-page-hero" />
      <section className="py-20 sm:py-24" data-testid="services-detail-list">
        <div className="mx-auto grid max-w-[1500px] gap-6 px-5 sm:px-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <article id={service.id} key={service.id} className="grid gap-6 border border-industrial-line bg-industrial-surface p-6 sm:p-8 lg:grid-cols-[0.7fr_1.3fr]" data-testid={`service-detail-${service.id}`}>
                <div>
                  <Icon size={42} weight="fill" className="text-industrial-yellow" />
                  <p className="mt-6 font-mono text-xs uppercase tracking-[0.24em] text-industrial-muted">Service {String(index + 1).padStart(2, "0")}</p>
                  <h2 className="mt-3 font-heading text-3xl font-semibold uppercase text-industrial-text">{service.title}</h2>
                  <p className="mt-4 text-sm leading-7 text-industrial-muted">{service.text}</p>
                </div>
                <div className="grid content-between gap-8">
                  <ul className="grid gap-3 sm:grid-cols-2">
                    {service.items.map((item) => <li key={item} className="border border-industrial-line bg-white p-4 text-sm font-medium text-industrial-text">{item}</li>)}
                  </ul>
                  <Link to={service.link} data-testid={`service-detail-link-${service.id}`} className="w-fit font-mono text-xs font-bold uppercase tracking-[0.18em] text-industrial-yellow">Explore requirement →</Link>
                </div>
              </article>
            );
          })}
        </div>
      </section>
      <Footer />
    </main>
  );
}
